export enum EventEntryStatusOptions {
    inProgress = "in_progress", //User has not yet submitted the entry, but started working on it
    submitted = "submitted", //User submitted the entry, but the show staff needs to accept it
    complete = "complete", //User submitted the entry, and the show staff accepted it
    declined = "declined" //User submitted the entry, but the show staff declined it
};